export default function($) {
  // Responsive nav

  $(document).ready(function() {

    function children_width(children) {
      var total = 0;
      children.each(function() {
        var child_width = $(this).outerWidth();
        total += parseInt(child_width);
      });
      return total;
    }

    function visible_list_width(l) {
      return children_width($(l + ' > li:not(.nav-hide)'));
    }


    function first_invisible_item_width(l) {
      return parseInt($(l+' > li.nav-hide').first().outerWidth());
    }

    function first_visible_item(l) {
      return $(l+' > li:not(.nav-hide)').first();
    }

    function first_invisible_item(l) {
      return $(l+' > li.nav-hide').first();
    }

    function last_visible_item(l) {
       return $(l + ' > li:not(.nav-hide)').last();
    }

    function last_invisible_item(l) {
       return $(l + ' > li.nav-hide').last();
    }

    function balance(from_list, to_list) {
      var $opener = $('.main-nav-mobile-clone');

      var max = $('.main-header > .wrapper').width() - $opener.outerWidth() - $('.main-logo img').outerWidth() - 60;

      while(visible_list_width(from_list) > max) {
        last_visible_item(from_list).addClass('nav-hide');
        last_invisible_item(to_list).removeClass('nav-hide');
      }

      while((visible_list_width(from_list) + first_invisible_item_width(from_list)) <= max) {
        first_invisible_item(from_list).removeClass('nav-hide');
        first_visible_item(to_list).addClass('nav-hide');
      }

      if ($(from_list+' > li.nav-hide').length == 0) {
        $opener.hide();
        $('.main-nav .main-nav-visible .main-nav-items').css('right', 'auto');
      } else {
        $opener.show();
        $('.main-nav .main-nav-visible .main-nav-items').css('right', $opener.outerWidth() + 30);
      }
    }

    $('.js-nav-mobile-clone').click(function(e) {
      e.preventDefault();
      $('.main-nav-overflow-target').toggle();
      $(this).toggleClass('main-nav-mobile-button-active');
    });

    // Init
    $('.main-nav-overflow-target > li').addClass('nav-hide');
    $('.main-nav-overflow-target').hide();
    balance('.main-nav-overflow', '.main-nav-overflow-target');

    // On resize
    $(window).resize(function() {
      balance('.main-nav-overflow', '.main-nav-overflow-target');
    });

  });

  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('main-nav-mobile-button-active');
  });

  $('.menu-item-has-children').click(function () {
    $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).children('.sub-menu').slideToggle(speed);
    $(this).toggleClass('menu-item-has-children--active');
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }
  });

  // Styleguide nav
  $('.sg-nav-mobile-button').click(function () {
    $('.js-sg-nav').slideToggle(speed);
  });

  // Sticky header
  var sticky = new Waypoint.Sticky({
    element: $('.main-header')[0]
  })
}
